var _defs, _path, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220.22 220.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#222221;}.cls-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.39,223.5h0A110.11,110.11,0,0,1,3.27,113.39h0A110.11,110.11,0,0,1,113.39,3.28h0A110.11,110.11,0,0,1,223.5,113.39h0A110.11,110.11,0,0,1,113.39,223.5Z",
    transform: "translate(-3.27 -3.28)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 60.18,
    y: 85.57,
    width: 22.79,
    height: 73.62
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.74,79.2A13.59,13.59,0,1,0,61.27,65.61,13.54,13.54,0,0,0,74.74,79.2Z",
    transform: "translate(-3.27 -3.28)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.67,123.81c0-10.34,4.77-16.51,13.89-16.51,8.38,0,12.4,5.92,12.4,16.51v38.65h22.69V115.85c0-19.72-11.18-29.26-26.79-29.26a25.67,25.67,0,0,0-22.19,12.17V88.84H100.81v73.62h21.86Z",
    transform: "translate(-3.27 -3.28)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin1);
export default __webpack_public_path__ + "static/media/linkedin1.e50b8544a5fa20f5a7365dfc2d263210.svg";
export { ForwardRef as ReactComponent };